export function formatPrice(pence, currency = "gbp") {
  if (pence === 0 || pence == null) return "Free";
  const symbol = currency === "gbp" ? "£" : currency === "usd" ? "$" : "";
  return `${symbol}${(pence / 100).toFixed(2)}`;
}

export function fmtEventDateTime(s) {
  if (!s) return "";
  try {
    const d = new Date(s);
    const date = d.toLocaleDateString("en-GB", {
      weekday: "short", day: "numeric", month: "short", year: "numeric",
    });
    const time = d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
    return `${date} · ${time}`;
  } catch { return s; }
}

export function fmtDateOnly(s) {
  if (!s) return "";
  try {
    return new Date(s).toLocaleDateString("en-GB", {
      day: "numeric", month: "short", year: "numeric",
    });
  } catch { return s; }
}

export function fmtCutoff(s) {
  if (!s) return "";
  try {
    return new Date(s).toLocaleString("en-GB", {
      weekday: "short", day: "numeric", month: "short", year: "numeric",
      hour: "2-digit", minute: "2-digit",
    });
  } catch { return s; }
}
